module.exports = __webpack_public_path__ + "20fa2a54dd3d85204a3e3269242be104.png";